import { useSearchFriends } from 'hooks/queries/friends';
import {
  useAddPodParticipant,
  useDeletePodParticipant,
  usePrintingOrders,
} from 'hooks/queries/printOndemandeProducts/usePrintOnDemandeProduct';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/router';

const useManagePodEntrantModal = () => {
  const [selectedUniqueId, setSelectedUniqueId] = useState<string>();
  const router = useRouter();

  const printingOrderId = router.query.slug?.[1] || '';

  const formMethods = useForm({
    mode: 'onSubmit',
  });

  const handleSubmit = formMethods.handleSubmit(({ uniqueId }) => {
    setSelectedUniqueId(uniqueId);
  });
  // const queryClient = useQueryClient();
  const {
    queryResult: { data, isLoading: dataIsLoading },
    // queryKey: searchFriendsQueryKey,
  } = useSearchFriends(selectedUniqueId);
  const { data: printingOrderData, isLoading } = usePrintingOrders({ id: printingOrderId });

  const addParticipantMutation = useAddPodParticipant({ orderId: printingOrderId });
  const deleteParticipantMutation = useDeletePodParticipant({ orderId: printingOrderId });

  const handleAddUser = async (userId: string) => {
    await addParticipantMutation.mutate({
      printingOrder: `/printing_orders/${printingOrderId}`,
      user: `users/${userId}`,
    });

    formMethods.reset();
    setSelectedUniqueId(undefined);
  };

  const handleRemoveUser = (userId: string) => {
    deleteParticipantMutation.mutate({
      printingOrder: printingOrderId,
      user: `${userId}`,
    });
  };

  return {
    handleSubmit,
    formMethods,
    data,
    handleAddUser,
    participants: printingOrderData?.data?.participants,
    handleRemoveUser,
    isLoading,
    dataIsLoading,
  };
};

export default useManagePodEntrantModal;
